import _ from 'lodash';
import dataURLtoBlob from 'dataurl-to-blob';

import { TYPE_IMAGE, TYPE_VIDEO } from './request-credentials';

const IMAGE_PROPERTIES = ['width', 'height', 'file_name', 'original_file_name'];
const VISITOR_UPLOADS_FOLDER_ID = 'visitor-uploads';
const MEMBERS_AREA_FOLDER = 'Members Area';

export { TYPE_IMAGE, TYPE_VIDEO };
export default function uploadFile(name, file, type, { uploadToken, uploadUrl }) {
  const formData = new FormData();

  let blob = file;
  try {
    blob = dataURLtoBlob(blob);
  } catch (e) {}

  formData.append('media_type', type);
  formData.append('upload_token', uploadToken);
  formData.append('file', blob, name);
  formData.append('parent_folder_id', VISITOR_UPLOADS_FOLDER_ID);
  formData.append('directory', MEMBERS_AREA_FOLDER);

  const request = new XMLHttpRequest();

  return new Promise((resolve, reject) => {
    const isResponseTypeSet = _.attempt(() => (request.responseType = 'json'));
    const isResponseJson = !_.isError(isResponseTypeSet);

    request.addEventListener('load', (event) => {
      const responseJson = isResponseJson ? event.target.response[0] : JSON.parse(event.target.response)[0];
      const data = type === TYPE_IMAGE ? _.pick(responseJson, IMAGE_PROPERTIES) : responseJson;
      resolve(data);
    });

    request.addEventListener('error', reject);
    request.open('POST', uploadUrl);
    request.send(formData);
  });
}
